import React, { forwardRef, Ref, useState } from 'react';

import { StyledCheckbox } from './Checkbox.styles';

import { CheckboxProps } from './Checkbox.types';

const Checkbox = forwardRef(
  (
    {
      name,
      customCheckIcon = null,
      onCheckboxChange = null,
      defaultValue = false,
      isDisabled = false,
      label = null,
      componentClassname = 'checkbox',
      customClassnames = '',
      customStyle = '',
      ...props
    }: CheckboxProps,
    ref: Ref<HTMLInputElement>,
  ) => {
    const [isChecked, setIsChecked] = useState(defaultValue);

    const toggleIsChecked = () => {
      const newValue = !isChecked;

      setIsChecked(newValue);

      if (onCheckboxChange) {
        onCheckboxChange(newValue);
      }
    };

    const onButtonClick = (event: Event) => {
      event.preventDefault();

      toggleIsChecked();
    };

    const onInputClick = () => {
      toggleIsChecked();
    };

    const getCheckboxContent = () => {
      if (!label) {
        return checkboxHtml;
      }

      return (
        <>
          {/* eslint-disable-next-line jsx-a11y/label-has-for */}
          <label className={`${componentClassname}__label-wrapper`}>
            {checkboxHtml}
            <span className={`${componentClassname}__label`}>{label}</span>
          </label>
        </>
      );
    };

    const checkboxHtml = (
      <>
        <input
          type="checkbox"
          name={name}
          className="sr-only checkbox"
          {...props}
          onChange={onInputClick}
          checked={isChecked}
          disabled={isDisabled}
          ref={ref}
        />
        <button
          type="button"
          className={`${componentClassname}__indicator`}
          disabled={isDisabled}
          onClick={() => onButtonClick(event)}
        >
          {isChecked &&
            (customCheckIcon || (
              <span className={`${componentClassname}__indicator-icon`}></span>
            ))}
        </button>
      </>
    );

    return (
      <StyledCheckbox
        className={`${componentClassname}__wrapper ${customClassnames} ${
          isDisabled ? `${componentClassname}__wrapper--is-disabled` : ''
        }`}
        customStyle={customStyle}
      >
        {getCheckboxContent()}
      </StyledCheckbox>
    );
  },
);

Checkbox.displayName = 'Checkbox';

export default Checkbox;
